// Deadlines view (SPEC §3.7) — all deadlines for the active Subject across Cases.
//
// User-entered in this slice; a later slice adds statute-derived deadlines
// (§4.1.4). The list + add-form + .ics export live in the shared DeadlinesPanel.

import { DeadlinesPanel } from "../components/DeadlinesPanel";

export function DeadlinesPage(): JSX.Element {
  return (
    <div>
      <h1 className="mb-2 text-2xl font-semibold text-slate-900">Deadlines</h1>
      <p className="mb-4 max-w-prose-narrow text-sm text-slate-600">
        Track filing and response deadlines across your cases. Add a deadline, mark it met when
        done, or export your deadlines to your own calendar (one-way — CaseLens never reads your
        calendar back).
      </p>
      <DeadlinesPanel />
    </div>
  );
}
